import { CurrentFilterType, FilterOptionType, FilterOptionWithValueType, ItemType } from '../models/transferList.types';

export const createFilterWithValueType = (filterArray: FilterOptionType[]) => {
  const res = [] as FilterOptionWithValueType[];
  if (filterArray.length === 0) return [];
  filterArray?.forEach((filter: FilterOptionType) => {
    res.push({ label: filter.label, value: filter.label, options: filter.options });
  });

  return res;
};

export const filterBothSearchbarAndFilters = (searchElement: ItemType[], currentFilters: CurrentFilterType[]) => {
  if (currentFilters?.length === 0) return searchElement;
  return searchElement.filter((el: ItemType) => {
    return currentFilters?.find((element: CurrentFilterType) => {
      const itemKey = el[element.label.toLowerCase()].toLowerCase();
      const filterValue = element.value.toLowerCase();
      return itemKey === filterValue;
    });
  });
};

export const searchElement = (item: ItemType[], formData: string) => {
  return item.filter((element: ItemType) => {
    if (element.title.toLowerCase().includes(formData.toLowerCase())) {
      return true;
    }
  });
};

export const filterOptionWithValue = (filterArray: FilterOptionType[]) => {
  const response = [] as FilterOptionWithValueType[];
  filterArray.forEach((filter: FilterOptionType) => {
    response.push({ ...filter, value: filter.label });
  });
  return response;
};
